import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { User } from "../../schema/types/user/entity";
import { FormItemValue } from "../../components/antd/form/FormItemValue";
import { FormLabel } from "../../components/antd/form/FormLabel";

interface Props {
  user: User;
}
export const Summary: React.FC<Props> = ({ user }) => {
  const hasTagLinks =
    Object.entries(user.tags || {}).filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
      .length > 0;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <div className={`${hasTagLinks ? "mb-8" : ""}`}>
              <FormLabel>Email</FormLabel>
              <FormItemValue>{user.email}</FormItemValue>
            </div>
            {hasTagLinks ? (
              <TagLinksTable
                tableId="user-info-tag-links"
                tags={Object.entries(user.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
